import { useResponsiveValue } from "../useResponsiveValue/useResponsiveValue.mjs";
const useBreakpoint = () => {
  if (process.env.NODE_ENV !== "production") {
    console.warn(
      `'useBreakpoint' has been deprecated. Use 'useResponsiveValue' instead: https://seek-oss.github.io/braid-design-system/components/useResponsiveValue`
    );
  }
  return useResponsiveValue()({
    mobile: "mobile",
    tablet: "tablet",
    desktop: "desktop"
  });
};
export {
  useBreakpoint
};
